<template>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{propItem ? "Edit PDF" : "Add PDF"}}</p>
      </header>
      <section class="modal-card-body">
        <b-field label="App Menu Pdf Item:">
            <b-select :disabled="role !== 'admin' && role !== 'device' && isMigrated" v-model="appMenuPdfItemId">
                <option v-for="(appMenuPdf, id) in filteredAppMenuItems" :key="id" :value="appMenuPdf.id">{{appMenuPdf.appItemTitle}}</option>
            </b-select>
        </b-field>
        <b-field v-if="bAppMenuPdfItemError" style="color: red">
            Please choose an app menu PDF item.
          </b-field>
          <b-field label="Title:">
            <b-input :disabled="role === 'viewer'" type="text" v-model="title" placeholder="PDF title"></b-input>
          </b-field>
          <b-field v-if="bTitleError" style="color: red">
            Please enter a title.
          </b-field>
          <b-field label="Description:">
            <b-input :disabled="role === 'viewer'" type="textarea" v-model="description" placeholder="PDF description"></b-input>
          </b-field>
          <b-field label="Choose PDF file to upload:">
          </b-field>
            <b-button :disabled="role === 'viewer'" icon-left="file-upload" type="is-primary" outlined @click="addFile()">
              Local storage
            </b-button>
          <b-field v-if="bFileError" style="color: red">
            {{bFileMessage}}
          </b-field>
          <b-field v-if="itemFiles.length > 0">
            Chosen file: {{itemFiles[0].name}}
          </b-field>
          <b-field class="mt-3" v-if="resourceName.length > 0 && url.length > 0">
            <b class="mr-1">Currently uploaded file:</b>
            <a :href="url" target="_blank">
                {{resourceName}}
            </a>
          </b-field>
          <b-field class="mt-3" v-if="resourceName.length > 0 && url.length > 0">
            <iframe
                :src="url"
                frameBorder="0"
                scrolling="auto"
                height="50%"
                width="50%"
            ></iframe>
          </b-field>

      </section>
      <footer class="modal-card-foot">
        <b-button :disabled="role === 'viewer'" v-if="propItem" type="is-info" @click="editPdf">Save</b-button>
        <b-button :disabled="role === 'viewer'" icon-left="plus" v-else type="is-info" @click="addPdf">Add new PDF</b-button>
        <b-button type="is-light" @click="closeModal()">Cancel</b-button>
        <input style="display: none" @change="fileUploaded" id="fileSelect" name="fileSelect" type="file">
      </footer>

    </div>
    </template>

<script>

export default {
  name: 'AppMenuPdfAddEdit',
  props: ['propItem', 'propAppMenuPdfItemId', 'propParentFn'],
  data: () => {
    return {
      title: '',
      description: '',
      resourceName: '',
      url: '',
      bTitleError: false,
      bFileError: false,
      bAppMenuPdfItemError: false,
      bFileMessage: '',
      itemFiles: [],
      loadingComponent: null,
      deletePreviousFile: true,
      appMenuPdfItemId: '',
      filteredAppMenuItems: {},
      pdfId: '',
      initialAppMenuPdfItemId: ''
    }
  },
  mounted: function () {
    this.filteredAppMenuItems = Object.assign({}, this.appMenu.items.filter(x => x.type === 'pdf'))
    if (this.propItem) {
      this.pdfId = this.propItem.id
      this.title = this.propItem.title
      this.description = this.propItem.desc
      this.resourceName = this.propItem.fileName
      this.url = this.propItem.url
      this.appMenuPdfItemId = this.propItem.appMenuPdfId
      this.initialAppMenuPdfItemId = this.propItem.appMenuPdfId
    }
  },
  computed: {
    addOns () {
      return this.$store.state.addOns
    },
    appMenuPdfs () {
      return this.$store.state.appMenuPdfs
    },
    appMenu () {
      return this.$store.state.appMenu
    },
    role () {
      return this.$store.state.role
    }
  },
  methods: {
    closeWindow () {
      if (this.propParentFn) {
        this.propParentFn()
      }
      this.$parent.close()
      this.loadingComponent.close()
    },
    showAlert (isAdd) {
      this.$buefy.dialog.alert({
        title: 'Operation faild',
        message: isAdd ? 'Adding PDF failed. Please try again.' : 'Editing PDF failed. Please try again.',
        type: 'is-danger',
        hasIcon: true,
        icon: 'times-circle',
        iconPack: 'fa',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    addFile () {
      if (this.role !== 'viewer') {
        document.getElementById('fileSelect').click()
      }
    },
    fileUploaded (e) {
      let files = e.target.files
      this.bFileError = false
      this.itemFiles = [files[0]]
    },
    editPdf () {
      if (this.role !== 'viewer') {
        this.globalLogger('edit pdf')
        this.bTitleError = false
        this.bFileError = false
        this.bAppMenuPdfItemError = false
        if (this.appMenuPdfItemId === '') {
          this.bAppMenuPdfItemError = true
        } else if (this.title === '') {
          this.bTitleError = true
        } else if (this.itemFiles.length === 0 && this.resourceName === '') {
          this.bFileError = true
          this.bFileMessage = 'Please upload a file.'
        } else if (this.itemFiles[0] && this.itemFiles[0].type !== 'application/pdf') {
          this.bFileError = true
          this.bFileMessage = 'Incompatible file format! The supported type is .pdf.'
          this.itemFiles = []
        } else if (this.itemFiles[0] && this.itemFiles[0].size >= 52428800) {
          this.bFileError = true
          this.bFileMessage = 'Resource too big! Maximum image size is 50 MB.'
          this.itemFiles = []
        } else {
          this.loadingComponent = this.$buefy.loading.open()
          if (this.itemFiles[0]) { // se menuva slika
            let ref = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/AppMenuPdfs/' + this.itemFiles[0].name)
            ref.put(this.itemFiles[0]).then((snapshot) => {
              ref.getDownloadURL().then((url) => {
                this.globalLogger('File ' + this.itemFiles[0].name + ' successfully uploaded at ' + url)

                // change image url of existing pdf with the same file
                for (let pdfAppMenuId in this.appMenuPdfs) {
                  for (let pdfId in this.appMenuPdfs[pdfAppMenuId]) {
                    if (this.appMenuPdfs[pdfAppMenuId][pdfId].fileName === this.itemFiles[0].name) {
                      this.$store.state.database.ref('/neoslide/appMenuPdfs/' + this.$store.state.workspaceId + '/' + pdfAppMenuId + '/' + pdfId).update({
                        url: url
                      }).catch(error => {
                        this.globalLogger(error)
                        this.closeWindow()
                        this.showAlert(false)
                      })
                    }
                  }
                }

                this.$store.state.database.ref('/neoslide/appMenuPdfs/' + this.$store.state.workspaceId + '/' + this.appMenuPdfItemId + '/' + this.pdfId).update({
                  title: this.title,
                  desc: this.description,
                  fileName: this.itemFiles[0].name,
                  url: url
                }).then(() => {
                  this.deletePreviousRecord()

                  this.deletePreviousFile = true
                  this.globalLogger('delete previous file is true')

                  // check if previous file is used by another pdf
                  for (let pdfAppMenuId in this.appMenuPdfs) {
                    for (let pdfId in this.appMenuPdfs[pdfAppMenuId]) {
                      if (this.appMenuPdfs[pdfAppMenuId][pdfId].fileName === this.resourceName) {
                        this.globalLogger('delete prev file is false')
                        this.deletePreviousFile = false
                      }
                    }
                  }

                  // delete previous file
                  if (this.deletePreviousFile) {
                    this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/AppMenuPdfs/' + this.resourceName).delete()
                      .then(() => {
                        this.closeWindow()
                      })
                      .catch(error => {
                        this.globalLogger('could not delete previous file', error)
                        this.closeWindow()
                      })
                  } else {
                    this.closeWindow()
                  }
                }).catch(error => {
                  this.globalLogger(error)
                  this.closeWindow()
                  this.showAlert(false)
                })
              })
            }).catch(error => {
              this.globalLogger('Submit files error: ', error)
              this.closeWindow()
              this.showAlert(false)
            })
          } else { // ne se menuva slika
            this.$store.state.database.ref('/neoslide/appMenuPdfs/' + this.$store.state.workspaceId + '/' + this.appMenuPdfItemId + '/' + this.pdfId).update({
              title: this.title,
              desc: this.description,
              fileName: this.resourceName,
              url: this.url
            }).then(() => {
              this.deletePreviousRecord()
              this.closeWindow()
            }).catch(error => {
              this.globalLogger(error)
              this.closeWindow()
              this.showAlert(false)
            })
          }
        }
      }
    },
    addPdf () {
      if (this.role !== 'viewer') {
        this.globalLogger('submit item')
        this.bTitleError = false
        this.bFileError = false
        this.bAppMenuPdfItemError = false
        if (this.appMenuPdfItemId === '') {
          this.bAppMenuPdfItemError = true
        } else if (this.title === '') {
          this.bTitleError = true
        } else if (this.itemFiles.length === 0 && this.resourceName === '') {
          this.bFileError = true
          this.bFileMessage = 'Please upload a file.'
        } else if (this.itemFiles[0] && this.itemFiles[0].type !== 'application/pdf') {
          this.bFileError = true
          this.bFileMessage = 'Incompatible file format! The supported type is .pdf.'
          this.itemFiles = []
        } else if (this.itemFiles[0] && this.itemFiles[0].size >= 52428800) {
          this.bFileError = true
          this.bFileMessage = 'Resource too big! Maximum image size is 50 MB.'
          this.itemFiles = []
        } else {
          this.loadingComponent = this.$buefy.loading.open()
          let ref = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/AppMenuPdfs/' + '/' + this.itemFiles[0].name)
          ref.put(this.itemFiles[0]).then((snapshot) => {
            ref.getDownloadURL().then((url) => {
              this.globalLogger('File ' + this.itemFiles[0].name + ' successfully uploaded at ' + url)

              // change image url of existing pdf with the same file
              for (let pdfAppMenuId in this.appMenuPdfs) {
                for (let pdfId in this.appMenuPdfs[pdfAppMenuId]) {
                  if (this.appMenuPdfs[pdfAppMenuId][pdfId].fileName === this.itemFiles[0].name) {
                    this.$store.state.database.ref('/neoslide/appMenuPdfs/' + this.$store.state.workspaceId + '/' + pdfAppMenuId + '/' + pdfId).update({
                      url: url
                    }).catch(error => {
                      this.globalLogger(error)
                      this.closeWindow()
                      this.showAlert(false)
                    })
                  }
                }
              }

              let maxOrder = -1
              for (let id in this.appMenuPdfs[this.appMenuPdfItemId]) {
                const docOrder = this.appMenuPdfs[this.appMenuPdfItemId][id].order || 0
                if (docOrder > maxOrder) {
                  maxOrder = docOrder
                }
              }

              let newPdfRef = this.$store.state.database.ref('/neoslide/appMenuPdfs/' + this.$store.state.workspaceId + '/' + this.appMenuPdfItemId).push()
              newPdfRef.set({
                id: newPdfRef['key'],
                title: this.title,
                desc: this.description,
                fileName: this.itemFiles[0].name,
                url: url,
                order: maxOrder + 1
              }).then(() => {
                this.closeWindow()
              }).catch(error => {
                this.globalLogger(error)
                this.closeWindow()
                this.showAlert(true)
              })
            })
          }).catch(error => {
            this.globalLogger('Submit files error: ', error)
            this.closeWindow()
            this.showAlert(true)
          })
        }
      }
    },
    deletePreviousRecord () {
      this.globalLogger('delete prev record', this.initialAppMenuPdfItemId)
      if (this.initialAppMenuPdfItemId !== this.appMenuPdfItemId) {
        this.$store.state.database.ref('/neoslide/appMenuPdfs/' + this.$store.state.workspaceId + '/' + this.initialAppMenuPdfItemId + '/' + this.pdfId).remove()
      }
    },
    closeModal () {
      if (this.propParentFn) {
        this.propParentFn()
      }
      this.$parent.close()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/appmenu/AppMenuPdfAddEdit.vue